/**
 * @generated SignedSource<<14833128143bbb8b58a20c475be2c337>>
 * @relayHash f3daba5c1d36d154929398d826658f41
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID be2e854a482c526c0bee63fe1b2baaddf9f7f60f15ff182fbde08a76442d8943

import type { ConcreteRequest, Query } from 'relay-runtime';
export type ContentPropertiesQueryWithBodyRepresentationQuery$variables = {
  contentId?: string | null | undefined;
  versionOverride?: number | null | undefined;
};
export type ContentPropertiesQueryWithBodyRepresentationQuery$data = {
  readonly content: {
    readonly nodes: ReadonlyArray<{
      readonly body: {
        readonly dynamic: {
          readonly representation: string | null | undefined;
        } | null | undefined;
      } | null | undefined;
      readonly id: string | null | undefined;
      readonly metadata: {
        readonly frontend: {
          readonly fabricEditorSupported: boolean | null | undefined;
        } | null | undefined;
      };
      readonly operations: ReadonlyArray<{
        readonly operation: string | null | undefined;
        readonly targetType: string | null | undefined;
      } | null | undefined> | null | undefined;
      readonly properties: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null | undefined;
          readonly key: string | null | undefined;
          readonly value: string | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly type: string | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type ContentPropertiesQueryWithBodyRepresentationQuery = {
  response: ContentPropertiesQueryWithBodyRepresentationQuery$data;
  variables: ContentPropertiesQueryWithBodyRepresentationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "versionOverride"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      },
      {
        "kind": "Variable",
        "name": "version",
        "variableName": "versionOverride"
      }
    ],
    "concreteType": "PaginatedContentListWithChild",
    "kind": "LinkedField",
    "name": "content",
    "plural": false,
    "selections": [
      {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "ScalarField",
            "name": "type"
          },
          {
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "editor"
              }
            ],
            "concreteType": "PaginatedJsonContentPropertyList",
            "kind": "LinkedField",
            "name": "properties",
            "plural": false,
            "selections": [
              {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "key"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "value"
                  }
                ]
              }
            ],
            "storageKey": "properties(key:\"editor\")"
          },
          {
            "concreteType": "OperationCheckResult",
            "kind": "LinkedField",
            "name": "operations",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "operation"
              },
              {
                "kind": "ScalarField",
                "name": "targetType"
              }
            ]
          },
          {
            "concreteType": "ContentBodyPerRepresentation",
            "kind": "LinkedField",
            "name": "body",
            "plural": false,
            "selections": [
              {
                "concreteType": "ContentBody",
                "kind": "LinkedField",
                "name": "dynamic",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "representation"
                  }
                ]
              }
            ]
          },
          {
            "concreteType": "ContentMetadata",
            "kind": "LinkedField",
            "name": "metadata",
            "plural": false,
            "selections": [
              {
                "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                "kind": "LinkedField",
                "name": "frontend",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "fabricEditorSupported"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ContentPropertiesQueryWithBodyRepresentationQuery",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ContentPropertiesQueryWithBodyRepresentationQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "f3daba5c1d36d154929398d826658f41",
    "id": "be2e854a482c526c0bee63fe1b2baaddf9f7f60f15ff182fbde08a76442d8943",
    "metadata": {},
    "name": "ContentPropertiesQueryWithBodyRepresentationQuery",
    "operationKind": "query",
    "text": "query ContentPropertiesQueryWithBodyRepresentationQuery($contentId:ID,$versionOverride:Int){content(id:$contentId,version:$versionOverride){nodes{id,type,properties(key:\"editor\"){nodes{id,key,value}},operations{operation,targetType},body{dynamic{representation}},metadata{frontend{fabricEditorSupported}}}}}"
  }
};
})();

(node as any).hash = "5d011eb8e7550fa243322c900f718bd5";

export default node;
